import axios from 'axios';
import { getTrailersQuery } from './queries';
import Split from '../split';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';
import { renameKey } from '../../utils';

const getTrailers = async (includeDeleted, hId) => {
    try {
        const useExpressMigration = Split.getBooleanTreatment('use_express_migration_endpoints');
        const migrationQueryBuilder = useExpressMigration ? buildExpressQuery : buildLoopbackQuery;
        const query = getTrailersQuery({ ...(!includeDeleted && { filterDeleted: true }), ...(hId && { haulingId: hId }), queryBuilder: migrationQueryBuilder });
        const response = await axios.get(query);
        if (useExpressMigration) {
            renameKey(response.data, '_id', 'id');
        }

        return { trailers: response.data };
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error getting trailers:', error);
        return { trailers: [] };
    }
};

export default getTrailers;
